export const faqData = {
  heading: "Frequently Asked Questions",
  subHeading:
    "Here are some of our FAQs. If you have any other questions you’d like answered please feel free to email us.",
  faqs: [
    {
      question: "What is Bookmark?",
      answer:
        "Bookmark is the best bookmarking app on the market that boosts of a clean and simple interface to organize your favourite websites. Open a new browser tab and see your sites load instantly. ",
    },
    {
      question: "How can I request a new browser?",
      answer:
        "You can request a new browser through our dedicated App store. Visit our store of Google Play or Apple Store. Contact our support team if you encounter any troubles installing the application on your device.",
    },
    {
      question: "Is there a mobile app?",
      answer:
        "Yes! We recently launched a mobile app version for android and iOS. You can proceed to your respective App stores to download Bookmark.",
    },
    {
      question: "What about other Chromium browsers?",
      answer:
        "Chromium browsers are currently in development and scheduled to be released in due time. Our developers are working round the clock to push the final app into production.",
    },
  ],
  faqButton: {
    text:"More Info",
    link: "/"
  }
};
